module.exports = __webpack_public_path__ + "img/checked-text-header.dfd99beb.svg";